import { Component, OnInit, PLATFORM_ID, Inject } from "@angular/core";
import { AppService } from "../app.service";
import { FormBuilder, Validators, FormControl } from "@angular/forms";
import {
  Event as RouterEvent,
  ActivatedRoute,
  Router,
  NavigationEnd,
} from "@angular/router";
import { googleNearResult } from "../google/nearplaceresult";
import { NgxSpinnerService } from "ngx-spinner";
import { Common } from "../common/common";
import { isPlatformBrowser } from "@angular/common";
import { environment } from "src/environments/environment";

declare var $: any;
declare var google;
declare var gtag;
declare var fbq;
declare var getBudgetWords: any;

@Component({
  selector: "app-listing",
  templateUrl: "./listing.component.html",
  styleUrls: ["./listing.component.css"],
})
export class ListingComponent implements OnInit {
  public alwarBounds: any;
  public options: any;
  public homesearch: any = {};
  public div1Function: Boolean = false;
  public div2Function: Boolean = false;
  public div3Function: Boolean = false;
  public div4Function: Boolean = false;
  public display: Boolean = true;
  cityList:any =[];
  keyword = 'name';
  selectCityName:any;
  initialValue:any;
  eventName:any;
  subLocality: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private fb: FormBuilder,
    private service: AppService,
    private route: ActivatedRoute,
    private router: Router,
    private nearPlace: googleNearResult,
    private spinner: NgxSpinnerService,
    private common: Common
  ) {
     
    //check data if search data by city
    this.service.post('/getCityNameByState',{state_id:33}).subscribe((data:any)=>{
      if(data[0].error == 0){
        this.cityList=data[0].result;

        this.initialValue = this.service.getSelectedCity.name;

        var cityName=this.route.snapshot.paramMap.get('city').split('-').pop();

        if(cityName != null){
          
          var searchValue = this.cityList.filter(function (keyData) {
            return keyData.slug == cityName;
          });

          if(searchValue.length>0 && cityName != this.service.getSelectedCity.slug){
            var defaultCity={'categoryType':'buy','showCategoryLabel':'buy','id':searchValue[0].id,'name':searchValue[0].name, 'slug':searchValue[0].slug};
            localStorage.setItem('selSearchCity', JSON.stringify(defaultCity));
          }

          if(searchValue.length==0){

            // this.router.navigateByUrl('404');

          }

        }

        this.getAllProperty();
        this.getAllPropertyWithScroll();

      }
    });

  }

  p: number = 1;

  public property_type = new FormControl("");
  public mobile_sort_by = new FormControl("5");
  private propertyTypeName: string;
  public headingTag: string;
  public breadCrumbType: string;

  scrollDistance = 2;
  throttle = 300;
  properties = [];
  totalProperty = 0;
  offset: any = 0;
  limit: any = 15;
  notEmptyPost = true;
  notscrolly = true;
  propertyType: string = "";
  innerWidth:number;
  val:any;
  changePropertyType:boolean;
  changeLookingType:boolean;
  sortingChange:boolean = false;

  ngOnInit() {
    this.initialValue = this.getSelectedCity.name;

    this.router.events.subscribe((ev) => { 
      if (ev instanceof NavigationEnd) {  
        this.initialValue = this.service.getSelectedCity.name;
        this.getAllProperty();
        // this.getPayingGuest('no'); 
       }
    });
   
    this.innerWidth = window.innerWidth;
    if (this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state) {
      var extraState = this.router.getCurrentNavigation().extras.state;

      if (extraState.max_price) {
        this.searchForm.patchValue({ max_budget: extraState.max_price });
      }
    }

    this.route.data.subscribe((data) => {
      if (data.heading_tag) {
        this.headingTag = (data.heading_tag).replaceAll(':city',this.getSelectedCity.name);
      } else {
        this.headingTag = "";
      }

      if (data.breadcrumb_type) {
        this.breadCrumbType = data.breadcrumb_type;
      } else {
        this.breadCrumbType = "";
      }

      if (data.title) {
        this.service.setTitle((data.title).replaceAll(':city',this.getSelectedCity.name));
        this.service.setMetaTags({ property: "og:title", content: (data.title).replaceAll(':city',this.getSelectedCity.name) });
      }

      if (data.keywords) {
        this.service.setMetaTags({ name: "keywords", content: data.keywords });
      }

      if (data.description) {
        this.service.setMetaTags({
          name: "description",
          content: (data.description).replaceAll(':city',this.getSelectedCity.name),
        });
        this.service.setMetaTags({
          property: "og:description",
          content: (data.description).replaceAll(':city',this.getSelectedCity.name),
        });
      }

      if (data.property_type) {
        this.searchForm.patchValue({
          "property_type":data.property_type
        })
      }

      //set default value when user search to home page
      if (
        isPlatformBrowser(this.platformId) &&
        localStorage.getItem("homesearch")
      ) {
        var homeData = JSON.parse(localStorage.getItem("homesearch"));

        if (homeData.location_lat && homeData.location_long) {
          this.searchForm.patchValue({
            location_lat: homeData.location_lat,
            location_long: homeData.location_long,
            location: homeData.location,
          });
        }

        if (
          this.searchForm.value.property_type &&
          (this.searchForm.value.property_type == "1" || this.searchForm.value.property_type == "2")
        ) {
          
          this.searchForm.patchValue({
            property_types: homeData.propertytype_subcat,
          });
          if(homeData.propertytype_subcat.includes("5,6,commercialland")){
            this.searchForm.patchValue({ property_typesvalues: '9,commercialplot'});
          }
          else if(homeData.propertytype_subcat.includes("commercialplot")){
            this.searchForm.patchValue({property_typesvalues: homeData.propertytype_subcat,});
          }
        }

        if (this.searchForm.value.property_type && this.searchForm.value.property_type == "3") {
          this.searchForm.patchValue({
            pg_for: homeData.propertytype_subcat,
          });
        }

        localStorage.removeItem("homesearch");
      }

      if (data.propertytype_name) {
        this.propertyTypeName = data.propertytype_name;
      }

      var CompleteUrl = this.router.url;

      data.looking_type = "";
      if(CompleteUrl.includes("residential")|| CompleteUrl.includes("Independent") || CompleteUrl.includes("bhk-for-rent-in") || CompleteUrl.includes("bhk-for-sale-in")){

        data.looking_type = "1";

      }else if(CompleteUrl.includes("commercial")){

        data.looking_type = "2";

      }else if(CompleteUrl.includes("agriculture")){

        data.looking_type = "3";

      }else if(CompleteUrl.includes("industrial")){

        data.looking_type = "4";

      }else if(CompleteUrl.includes("new-property")){

        data.looking_type = "1"

      }

      if (data.looking_type) {
        var lookingSubCatTypes = "";
        if (data.looking_type == "1") {
          this.div1Function = true;
          if(localStorage.getItem("propertyTypes") === null){
            lookingSubCatTypes = "1,2,4";            
            if(this.searchForm.value.property_types === '' && this.searchForm.value.noof_bhk != ''){
              lookingSubCatTypes = ""; 
            }  
          }else {
            lookingSubCatTypes = this.getLookingPropertyType();
          }
          
        } else if (data.looking_type == "2" ) {
          this.div2Function = true;
          if(localStorage.getItem("propertyTypes") === null){
          lookingSubCatTypes = "5,6,commercialland";
          }else {
            lookingSubCatTypes = this.getLookingPropertyType();
          }
        } else if (data.looking_type == "3" ) {
          this.div3Function = true;
          if(localStorage.getItem("propertyTypes") === null){
          lookingSubCatTypes = "8,9";
          }else {
            lookingSubCatTypes = this.getLookingPropertyType();
          }
        } else if (data.looking_type == "4") {
          this.div4Function = true;
          if(localStorage.getItem("propertyTypes") === null){
            lookingSubCatTypes = "10,13";
            }else {
              lookingSubCatTypes = this.getLookingPropertyType();
            }
        } else if (data.looking_type == "5") {
          if(localStorage.getItem("pgFor") === null){
            lookingSubCatTypes = "1,2,3";
          }else {
            lookingSubCatTypes = localStorage.getItem("pgFor");
            localStorage.removeItem("pgFor");
          }
        }
        
        if (
          !this.searchForm.value.property_types &&
          !this.searchForm.value.pg_for
        ) {
          if (data.looking_type == "5") {
            this.searchForm.patchValue({ pg_for: lookingSubCatTypes });
          } else {
            this.searchForm.patchValue({ property_types: lookingSubCatTypes});

            if(lookingSubCatTypes == "5,6,commercialland"){
              this.searchForm.patchValue({ property_typesvalues: "9,commercialplot"});
            }
          }
        }

        const getNoOfBhk = localStorage.getItem("noofBHK");
        if(getNoOfBhk !== null){
          this.searchForm.patchValue({
            "noof_bhk":getNoOfBhk
          })
          localStorage.removeItem("noofBHK");
        }

        if(localStorage.getItem("pgAvailable") !== null){
          this.searchForm.patchValue({
            "pg_available":localStorage.getItem("pgAvailable")
          })
          localStorage.removeItem("pgAvailable");
        }

        if(localStorage.getItem("minBudget") !== null){
          this.searchForm.patchValue({
            "min_budget":localStorage.getItem("minBudget")
          })
          localStorage.removeItem("minBudget");
        }

        if(localStorage.getItem("maxBudget") !== null){
          this.searchForm.patchValue({
            "max_budget":localStorage.getItem("maxBudget")
          })
          localStorage.removeItem("maxBudget");
        }

        if(localStorage.getItem("location") !== null){
          this.searchForm.patchValue({
            "location":localStorage.getItem("location"),
            "location_lat":localStorage.getItem("locationLat"),
            "location_long":localStorage.getItem("locationLong"),
          })
          localStorage.removeItem("location");
          localStorage.removeItem("locationLat");
          localStorage.removeItem("locationLong");
        }
      }

      $("body").css("overflow", "visible");
    });

    if (isPlatformBrowser(this.platformId)) {
      window.scrollTo(0, 0);
    }

    this.uploadBudgetValue(this.searchForm.value.property_type);
    // this.getAllProperty();

    this.searchForm.get("property_type").valueChanges.subscribe((val) => {
      if(this.innerWidth >700){
        var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));
        var cityUrl = this.route.snapshot.paramMap.get("city");
        this.subLocality = this.route.snapshot.paramMap.get("sublocality");

          if (val === "2") {
            selectedCityData.categoryType ='buy';
            selectedCityData.showCategoryLabel ='Buy';

            if(cityUrl.includes("pg-in")){

              var update = cityUrl.replace("pg","property");
              this.router.navigateByUrl("/buy/"+update);

            }else if(this.subLocality){

              this.router.navigateByUrl("/buy/"+cityUrl+"/"+this.subLocality)

            }else{

              this.router.navigateByUrl("/buy/"+cityUrl);
              
            }

          } else if (val === "1") {
            selectedCityData.categoryType ='rent';
            selectedCityData.showCategoryLabel ='Rent';

            if(cityUrl.includes("pg-in")){

              var update = cityUrl.replace("pg","property");
              this.router.navigateByUrl("/rent/"+update);

            }else if (this.subLocality){

              this.router.navigateByUrl("/rent/"+cityUrl+"/"+this.subLocality)

            }else{

              this.router.navigateByUrl("/rent/"+cityUrl);

            }

          } else if (val === "3") {

            selectedCityData.categoryType ='pg';
            selectedCityData.showCategoryLabel ='PG';
            this.router.navigateByUrl("/pg/pg-in-"+this.getSelectedCity.slug);

          }

          localStorage.setItem('selSearchCity', JSON.stringify(selectedCityData));
          // close all property category  when user reset property search type
          // this.resetFilters();
          this.div2Function = false;
          this.div1Function = false;
          this.div3Function = false;
          this.div4Function = false;
          this.uploadBudgetValue(val);
        } else {

          if(val === "3"){
            this.searchForm.patchValue({
              "pg_for": "1,2,3"
            })
          }
          this.changePropertyType=true;
          this.resetFilters();
          this.div2Function = false;
          this.div1Function = false;
          this.div3Function = false;
          this.div4Function = false;
          this.uploadBudgetValue(val);
        }
    });

    this.mobile_sort_by.valueChanges.subscribe((val)=>{
      this.sortingChange = true;
      this.searchForm.patchValue({
        "sort_by":val
      })
      $(".popup-content").toggleClass("popup-show");
    })

    this.searchForm.valueChanges.subscribe((val) => {
      if(this.innerWidth>700){
        this.properties = [];
        this.offset = 0;
        this.limit = 15;
        this.notEmptyPost = true;
        this.notscrolly = true;
        this.getAllProperty();
        this.totalProperty = 0;
      }else if(this.sortingChange && this.innerWidth <700){
        this.properties = [];
        this.offset = 0;
        this.limit = 15;
        this.notEmptyPost = true;
        this.notscrolly = true;
        this.getAllProperty();
        this.sortingChange = false;
        this.totalProperty = 0;
      }
    });

    // this.getAdvertisementBanner();

    if (isPlatformBrowser(this.platformId)) {
      
      this.alwarBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(environment.norteastLatLongFirst, environment.norteastLatLongSecond),
        new google.maps.LatLng(environment.southwestLatLongFirst, environment.southwestLatLongSecond)
      );

      this.options = {
        bounds: this.alwarBounds,
        componentRestrictions: { country: "IN" },
        strictBounds: environment.strictBounds,
      };
    }

    this.service.post('/getCityNameByState',{state_id:33}).subscribe((data:any)=>{
      if(data[0].error == 0){
        this.cityList=data[0].result;
      }
    });

  }

  searchCategory: string = this.getSelectedCity.categoryType;

  CityInputFocused(){
    $("#like").show();
  }

  getSelectCity(event:any){

    if(event != ""){
      $("#like").hide();
    }

    if(typeof event === 'object' && event !== null){  
      var data=JSON.parse(localStorage.getItem('selSearchCity'));
      data.id=event.id;
      data.name=event.name;
      data.slug=event.slug; 
      localStorage.setItem('selSearchCity', JSON.stringify(data)); 
      if(this.searchCategory=='pg'){
        this.router.navigateByUrl(this.searchCategory+'/pg-in-'+event.slug);
      }else{
        this.router.navigateByUrl(this.searchCategory+'/property-in-'+event.slug);
      } 
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    }

  }
  

  getLookingPropertyType(){
     let arg = localStorage.getItem("propertyTypes");
      localStorage.removeItem("propertyTypes");
      return arg;
  }

  openFilterForMobile() {
    $(".filterheader").addClass("filterheadershow");
  }
  openMobileFilter() {
    $("#filter").scrollTop(0);
    $(".filter").toggleClass("show-filter");
    $("body").css("overflow", "hidden");
  }
  hideSorting(){
    $(".popup-content").toggleClass("popup-show");
    }
  openMobileSort() {
    $(".popup-content").toggleClass("popup-show");
  }

  resetMobileFilter() {
    this.searchForm.patchValue({
      location_lat: "",
      location_long: "",
      location: "location",
      property_types: "",
      noof_bhk: "",
      sort_by: "",
      pg_available: "",
      pg_for: "",
      min_budget: "",
      max_budget: "",
    });
  }

  closeMobileFilter() {
    $(".filter1").scrollTop(0);
    if($(".filterheader").hasClass("filterheadershow")){
    $(".filterheader").removeClass("filterheadershow");
    }
  }

  get getSearchText() {
    var searchData = this.homesearch;

    var searchText = "";
    var propertyText = "";

    if (searchData.looking_type == "1") {
      propertyText += "Residential Properties for " + this.propertyType;
    } else if (searchData.looking_type == "2") {
      propertyText += "Commercial Properties for " + this.propertyType;
    } else if (searchData.looking_type == "3") {
      propertyText += "Agriculture Properties for " + this.propertyType;
    } else if (searchData.looking_type == "4") {
      propertyText += "Industry Properties for " + this.propertyType;
    }

    if (
      propertyText == "" &&
      searchData.location_sublocality != "" &&
      searchData.location_sublocality != null
    ) {
      searchText = this.propertyType + " in " + searchData.location_sublocality;
    } else if (propertyText != "" && searchData.location_sublocality != "") {
      searchText = propertyText + " in " + searchData.location_sublocality;
    } else if (propertyText != "" && searchData.location_sublocality == "") {
      searchText = propertyText;
    }

    return searchText;
  }

  div1Function1() {
    this.div4Function = false;
    this.div1Function = true;
    this.div2Function = false;
    this.div3Function = false;
    this.changeLookingType = true;

    var saleType = "";
    if(this.propertyTypeName == "buy"){
      saleType = "sale"
    }else if(this.propertyTypeName == "rent"){
      saleType = "rent";
    }
    
    if(innerWidth>700){
      this.searchForm.patchValue({
        "property_types":"1,2,4",
        "noof_bhk":"",
        "property_typesvalues":""

      })
    this.router.navigateByUrl(
      this.propertyTypeName + "/residential-property-for-"+saleType+"-in-"+this.service.getSelectedCity.slug
    );
    }
    else{
      this.searchForm.patchValue({
        "property_types":"1,2,4",
        "noof_bhk":"",
        "property_typesvalues":""

      })
    }
  }

  div2Function2() {
    this.div4Function = false;
    this.div1Function = false;
    this.div2Function = true;
    this.div3Function = false;
    this.changeLookingType = true;

    var saleType = "";
    if(this.propertyTypeName == "buy"){
      saleType = "sale"
    }else if(this.propertyTypeName == "rent"){
      saleType = "rent";
    }

    if(innerWidth>700){
      this.searchForm.patchValue({
        "property_types":"5,6,commercialland",
        "noof_bhk":"",
        "property_typesvalues":"9,commercialplot"
      })
      this.router.navigateByUrl(
        this.propertyTypeName + "/commercial-property-for-"+saleType+"-in-"+this.service.getSelectedCity.slug
      );
    
    }
    else {
      this.searchForm.patchValue({
        "property_types":"5,6,commercialland",
        "noof_bhk":"",
        "property_typesvalues":"9,commercialplot"
      })
    }
  }

  div3Function3() {
    this.div4Function = false;
    this.div1Function = false;
    this.div2Function = false;
    this.div3Function = true;
    this.changeLookingType = true;

    var saleType = "";
    if(this.propertyTypeName == "buy"){
      saleType = "sale"
    }else if(this.propertyTypeName == "rent"){
      saleType = "rent";
    }

    if(innerWidth>700){
      this.searchForm.patchValue({
        "property_types":"8,9",
        "noof_bhk":"",
        "property_typesvalues":""
      })
    this.router.navigateByUrl(
      this.propertyTypeName + "/agriculture-for-"+saleType+"-in-"+this.service.getSelectedCity.slug
    );
    }
    else {
      this.searchForm.patchValue({
        "property_types":"8,9",
        "noof_bhk":"",
        "property_typesvalues":""
      })
    }
  }

  div4Function4() {
    this.div4Function = true;
    this.div1Function = false;
    this.div2Function = false;
    this.div3Function = false;
    this.changeLookingType = true;

    var saleType = "";
    if(this.propertyTypeName == "buy"){
      saleType = "sale"
    }else if(this.propertyTypeName == "rent"){
      saleType = "rent";
    }

    if(innerWidth>700){
      this.searchForm.patchValue({
        "property_types":"10,13",
        "noof_bhk":"",
        "property_typesvalues":""
      })
    this.router.navigateByUrl(
      this.propertyTypeName + "/industrial-property-for-"+saleType+"-in-"+this.service.getSelectedCity.slug
    );
    }
    else {
      this.searchForm.patchValue({
        "property_types":"10,13",
        "noof_bhk":"",
        "property_typesvalues":""
      })
    }
  }

  advBanner: any = "";
  getAdvertisementBanner() {
    this.service.get("/getPropertyListinAdv").subscribe(
      (data: any) => {
        if (data[0].error == "0") {
          // this.advBanner = data[0];
        }
      },
      (error) => {
        console.log("in error");
      }
    );
  }

  uploadBudgetValue(val) {
    if (val == "1") {
      this.getRentbudgetMinValue(); //load budget min price as per property type
    } else if (val == "2") {
      this.getBuybudgetMinValue(); //load budget min price as per property type
    } else if (val == "3") {
      this.getPgbudgetMinValue(); //load budget min price as per property type
    }
  }

  searchForm = this.fb.group({
    property_type: [""],
    location_lat: [this.homesearch.location_lat],
    location_long: [this.homesearch.location_long],
    location: [this.homesearch.location],
    property_types: [""],
    property_typesvalues:[""],
    noof_bhk: [""],
    sort_by: ["5"],
    pg_available: [""],
    pg_for: [],
    min_budget: [""],
    max_budget: [""],
    possession_type:[""],
    listed_by:[""],
    sale_type:[""]
  });

  get f() {
      return this.searchForm.controls;
  }

  handleAddressChange(event, type = "") {

    if(environment.production){
      this.service.sendEvents("Completelisting_search_event", "listing_search_event", "Listing_Search_Event");

      fbq('track', "CompleteListing_Search_Event" , {
        content_term: this.searchCategory,
        content_type: event.formatted_address,
        content_title: this.router.url,
      });
    }

    this.eventName = event.name.toLowerCase().replace(/[^a-z0-9\s-]/g, '').replace(/[\s-]+/g, '-');

    if (type == "mannual" && event.target.value == "") {

        this.searchForm.patchValue({
          location: "",
          location_lat: "",
          location_long: "",
        });

        var data=JSON.parse(localStorage.getItem('homesearch'));
        data.location=event.formatted_address;
        data.location_lat=event.geometry.location.lat();
        data.location_long=event.geometry.location.lng(); 
        data.location_sublocality=event.name;
        data.looking_type='';
        data.propertytype_subcat=''; 
        localStorage.setItem('homesearch', JSON.stringify(data));

        this.router.navigateByUrl(this.propertyTypeName+"/property-in-"+this.getSelectedCity.slug+"/"+this.eventName)

    } else if (type == "address") {

        this.searchForm.patchValue({
          location: event.formatted_address,
          location_lat: event.geometry.location.lat(),
          location_long: event.geometry.location.lng(),
        });

        var data=JSON.parse(localStorage.getItem('homesearch'));
        data.location=event.formatted_address;
        data.location_lat=event.geometry.location.lat();
        data.location_long=event.geometry.location.lng(); 
        data.location_sublocality=event.name;
        data.looking_type='';
        data.propertytype_subcat=''; 
        localStorage.setItem('homesearch', JSON.stringify(data));

        this.router.navigateByUrl(this.propertyTypeName+"/property-in-"+this.getSelectedCity.slug+"/"+this.eventName)
      }
  }


  applyFilter() {
    if(this.changeLookingType || this.changePropertyType){
      var mobileRedirectUrl = "";
      var saleType = "";
      let propertyTypeValue = this.searchForm.value.property_type;
      var locality = this.route.snapshot.paramMap.get("sublocality");

      if (propertyTypeValue === "2") {
        mobileRedirectUrl += "/buy";
        saleType = "sale"
      } else if (propertyTypeValue === "1") {
        mobileRedirectUrl += "/rent";
        saleType = "rent"
      } else if (propertyTypeValue === "3") {
        mobileRedirectUrl += "/pg";
      }

      if (this.div1Function) {
        mobileRedirectUrl += "/residential-property-for-"+saleType+"-in-"+this.getSelectedCity.slug;
      } else if (this.div2Function) {
        mobileRedirectUrl += "/commercial-property-for-"+saleType+"-in-"+this.getSelectedCity.slug;
      } else if (this.div3Function) {
        mobileRedirectUrl +=  "/agriculture-property-for-"+saleType+"-in-"+this.getSelectedCity.slug;
      } else if (this.div4Function) {
        mobileRedirectUrl += "/industrial-property-for-"+saleType+"-in-"+this.getSelectedCity.slug;
      }


      if(this.searchForm.value.property_types){        
        localStorage.setItem("propertyTypes",this.searchForm.value.property_types);
      }

      if(this.searchForm.value.noof_bhk){ 
        localStorage.setItem("noofBHK",this.searchForm.value.noof_bhk);
      }

      if(this.searchForm.value.pg_for){
        localStorage.setItem("pgFor",this.searchForm.value.pg_for);
      }
      
      if(this.searchForm.value.pg_available){
        localStorage.setItem("pgAvailable",this.searchForm.value.pg_available);
      }

      if(this.searchForm.value.min_budget){
        localStorage.setItem("minBudget",this.searchForm.value.min_budget);
      }

      if(this.searchForm.value.max_budget){
        localStorage.setItem("maxBudget",this.searchForm.value.max_budget);
      }

      if(this.searchForm.value.property_typesvalues){
        localStorage.setItem("property_typesvalues",this.searchForm.value.max_budget);
      }

      if(this.searchForm.value.location){
        localStorage.setItem("location",this.searchForm.value.location);
        localStorage.setItem("locationLat",this.searchForm.value.location_lat);
        localStorage.setItem("locationLong",this.searchForm.value.location_long);
      }

      this.router.navigateByUrl(mobileRedirectUrl);
    }
    else {

      this.properties = [];
        this.offset = 0;
        this.limit = 15;
        this.notEmptyPost = true;
        this.notscrolly = true;
        this.getAllProperty();
        this.totalProperty = 0;
        $(".filter1").scrollTop(0);
        $(".filterheader").removeClass("filterheadershow");
    }
    
  }

  setPropertyTypeValue() {
    if(this.innerWidth >700){
    this.searchForm.patchValue({
      property_types: $(".property_type:checked")
        .map(function () {
          return this.value;
        })
        .get()
        .join(","),
    
    });
  }else {
    this.searchForm.patchValue({
      property_types: $(".looking_type:checked")
        .map(function () {
          return this.value;
        })
        .get()
        .join(","),
    
    });

  }
  }

  setPropertyTypeValues(event:any) {
    if(this.innerWidth >700){
      if(event.target.checked == true){
        let prop_Values = $(".property_typesvalues:checked").map(function () { return this.value; }).get().join(",")
  
        const values = prop_Values.split(',');
        const uniqueValues = [...new Set(values)];
        const newStr = uniqueValues.join(',');
  
        this.searchForm.patchValue({
          property_typesvalues: newStr,
        });
      }else{
        const values = this.searchForm.value.property_typesvalues.split(',');
        const filteredValues = values.filter(value => value !== event.target.value);
        const newStr = filteredValues.join(',');

        this.searchForm.patchValue({
          property_typesvalues: newStr
        });
      }
  }else {
    if(event.target.checked == true){
      let prop_Values = $(".property_typesvalues:checked").map(function () { return this.value; }).get().join(",")

      const values = prop_Values.split(',');
      const uniqueValues = [...new Set(values)];
      const newStr = uniqueValues.join(',');

      this.searchForm.patchValue({
        property_typesvalues: newStr,
      });
    }else{
      const values = this.searchForm.value.property_typesvalues.split(',');
      const filteredValues = values.filter(value => value !== event.target.value);
      const newStr = filteredValues.join(',');

      this.searchForm.patchValue({
        property_typesvalues: newStr
      });
    }
  }
  }

  get setProopertyTypeArray() {
    if (this.f.property_types.value) {
      return this.f.property_types.value.split(",");
    } else {
      return [];
    }
  }

  get setProopertyTypeValuesArray() {
    if (this.f.property_typesvalues.value) {
      return this.f.property_typesvalues.value.split(",");
    } else {
      return [];
    }
  }

  get getSelectedCity(){
    return this.service.getSelectedCity;
  }

  setNoOfBhkValue(e:any) {
    if(this.innerWidth >700){
      if(e.target.checked == true){
        let bhkVal = $(".bhk_checked:checked").map(function () {return this.value; }).get().join(",")

        const values = bhkVal.split(',');
        const uniqueValues = [...new Set(values)];
        const newStr = uniqueValues.join(',');

        console.log("value -",newStr);
        

        this.searchForm.patchValue({
          noof_bhk: newStr,
          property_typesvalues: ''
        });
      }else{
        const values = this.searchForm.value.noof_bhk.split(',');
        const filteredValues = values.filter(value => value !== e.target.value);
        const newStr = filteredValues.join(',');

        this.searchForm.patchValue({
          noof_bhk: newStr,
          property_typesvalues: ''
        });
        
      }
    }else {
     if(e.target.checked == true){
        let bhkVal = $(".bhk_checked:checked").map(function () {return this.value; }).get().join(",")

        const values = bhkVal.split(',');
        const uniqueValues = [...new Set(values)];
        const newStr = uniqueValues.join(',');

        console.log("value -",newStr);
        

        this.searchForm.patchValue({
          noof_bhk: newStr,
          property_typesvalues: ''
        });
      }else{
        const values = this.searchForm.value.noof_bhk.split(',');
        const filteredValues = values.filter(value => value !== e.target.value);
        const newStr = filteredValues.join(',');

        this.searchForm.patchValue({
          noof_bhk: newStr,
          property_typesvalues: ''
        });
        
      }

    }
  }

  getPropertyTypeUrl(event:any){
    this.router.navigateByUrl(event+'/property-in-'+this.getSelectedCity.slug);
  }

  // getSaleTypeUrl(event:any){
    
  //   var propertyTypeName="";
  //   var saleType = "";
  //   if(this.searchForm.value.property_type=='1'){
  //     propertyTypeName='rent';
  //     saleType = "rent";
  //   }else if(this.searchForm.value.property_type=='2'){
  //     propertyTypeName='buy';
  //     saleType = "sale";
  //   }

  //   var locality = this.route.snapshot.paramMap.get("sublocality");

  //   if(event.target.value == "2"){
  //     if(locality){
  //       this.router.navigateByUrl(propertyTypeName+"/new-property-for-"+saleType+"-in-"+this.getSelectedCity.slug+"/"+locality);
  //     }else{
  //       this.router.navigateByUrl(propertyTypeName+"/new-property-for-"+saleType+"-in-"+this.getSelectedCity.slug);
  //     }
  //   }else if(event.target.value == "1"){
  //     if(locality){
  //       this.router.navigateByUrl(propertyTypeName+"/resale-property-for-"+saleType+"-in-"+this.getSelectedCity.slug+"/"+locality); 
  //     }else{
  //       this.router.navigateByUrl(propertyTypeName+"/resale-property-for-"+saleType+"-in-"+this.getSelectedCity.slug); 
  //     }
  //   }
  // }

  // getPossessionUrl(event:any){

  //   var propertyTypeName="";
  //   var saleType = "";
  //   if(this.searchForm.value.property_type=='1'){
  //     propertyTypeName='rent';
  //     saleType = "rent";
  //   }else if(this.searchForm.value.property_type=='2'){
  //     propertyTypeName='buy';
  //     saleType = "sale";
  //   }

  //   var locality = this.route.snapshot.paramMap.get("sublocality");

  //   if(event.target.value == "1"){
  //     if(locality){
  //       this.router.navigateByUrl(propertyTypeName+"/ready-to-move-property-for-"+saleType+"-in-"+this.getSelectedCity.slug+"/"+locality)
  //     }else{
  //       this.router.navigateByUrl(propertyTypeName+"/ready-to-move-property-for-"+saleType+"-in-"+this.getSelectedCity.slug)
  //     }
  //   }else if(event.target.value == "2"){
  //     if(locality){
  //       this.router.navigateByUrl(propertyTypeName+"/under-construction-property-for-"+saleType+"-in-"+this.getSelectedCity.slug+"/"+locality)
  //     }else{
  //       this.router.navigateByUrl(propertyTypeName+"/under-construction-property-for-"+saleType+"-in-"+this.getSelectedCity.slug)
  //     }
  //   }
  // }

  setValueOFPg(event:any) {

    if(event == '1'){
      this.router.navigateByUrl('/pg/boys-pg-in-'+this.getSelectedCity.slug);
    }else if(event  == '2'){
      this.router.navigateByUrl('/pg/girls-pg-in-'+this.getSelectedCity.slug);
    }else if(event == "3"){
      this.router.navigateByUrl('/pg/both-pg-in-'+this.getSelectedCity.slug);
    }

    if(this.innerWidth >700){
    this.searchForm.patchValue({
      pg_for: $(".pg_for:checked")
        .map(function () {
          return this.value;
        })
        .get()
        .join(","),
    });
  }else {
    this.searchForm.patchValue({
      pg_for: $(".pgFor:checked")
        .map(function () {
          return this.value;
        })
        .get()
        .join(","),
    });

  }
  }

  setValueOfSaleType(){

    var saleTypeValue=$(".saleType:checked")
    .map(function () {
      return this.value;
    })
    .get()
    .join(",");

    this.searchForm.patchValue({
      sale_type:saleTypeValue
    });
  }

  setValueOfListedBy(){
    var listedByValue=$(".listedBy:checked")
    .map(function () {
      return this.value;
    })
    .get()
    .join(",");

    this.searchForm.patchValue({
      listed_by:listedByValue
    });
  }

  setValueOfPossessionType(){
    var possessionTypeValue=$(".possessionType:checked")
    .map(function () {
      return this.value;
    })
    .get()
    .join(",");

    this.searchForm.patchValue({
      possession_type:possessionTypeValue
    });
  }

  setValueOfPgAvl() {
    if(this.innerWidth >700){
    this.searchForm.patchValue({
      pg_available: $(".pg_available:checked")
        .map(function () {
          return this.value;
        })
        .get()
        .join(","),
    });
  }else {
    this.searchForm.patchValue({
      pg_available: $(".pgAvailable:checked")
        .map(function () {
          return this.value;
        })
        .get()
        .join(","),
    });
  }
  }

  get getPgAvlValue() {
    if (this.f.pg_available.value) {
      return this.f.pg_available.value.split(",");
    } else {
      return "";
    }
  }

  get getPgValue() {
    if (this.f.pg_for.value) {
      return this.f.pg_for.value.split(",");
    } else {
      return [];
    }
  }

  get getBhkValue() {
    if (this.f.noof_bhk.value) {
      return this.f.noof_bhk.value.split(",");
    } else {
      return "";
    }
  }

  location: string = "Alwar, Rajasthan";
  location_lat: number = 27.5898582;
  location_long: number = 76.6167212;
  whatsNearByModalMap(lat, long, location) {
    this.location = location;
    this.location_lat = lat;
    this.location_long = long;
    $(".nearestgoogleplace").trigger("click");
    this.nearByPlaceList("nearby", "nearby");
    $("#mapModal").modal("toggle");
  }

  getBudgetWords(value: any) {
    return getBudgetWords(value);
  }

  budgetMin: any = [];
  getBuybudgetMinValue() {
    this.budgetMin = [];
    this.budgetMin.push("500000");
    this.budgetMin.push("1000000");
    this.budgetMin.push("1500000");
    this.budgetMin.push("2000000");
    this.budgetMin.push("2500000");
    this.budgetMin.push("3000000");
    this.budgetMin.push("4000000");
    this.budgetMin.push("5000000");
    this.budgetMin.push("5500000");
    this.budgetMin.push("6000000");
    this.budgetMin.push("7000000");
    this.budgetMin.push("7500000");
    this.budgetMin.push("8000000");
    this.budgetMin.push("9000000");
    this.budgetMin.push("10000000");
    this.budgetMin.push("20000000");
    this.budgetMin.push("30000000");
    this.budgetMin.push("40000000");
    this.budgetMin.push("50000000");
    this.budgetMin.push("60000000");
    this.budgetMin.push("70000000");
    this.budgetMin.push("80000000");
    this.budgetMin.push("90000000");
    this.budgetMin.push("100000000");
  }

  getRentbudgetMinValue() {
    this.budgetMin = [];
    this.budgetMin.push("1000");
    this.budgetMin.push("3000");
    this.budgetMin.push("5000");
    this.budgetMin.push("10000");
    this.budgetMin.push("15000");
    this.budgetMin.push("20000");
    this.budgetMin.push("25000");
    this.budgetMin.push("30000");
    this.budgetMin.push("40000");
    this.budgetMin.push("50000");
    this.budgetMin.push("60000");
    this.budgetMin.push("70000");
    this.budgetMin.push("80000");
    this.budgetMin.push("90000");
    this.budgetMin.push("100000");
    this.budgetMin.push("200000");
    this.budgetMin.push("300000");
    this.budgetMin.push("400000");
    this.budgetMin.push("500000");
    this.budgetMin.push("600000");
    this.budgetMin.push("700000");
    this.budgetMin.push("800000");
    this.budgetMin.push("900000");
    this.budgetMin.push("1000000");
  }

  getPgbudgetMinValue() {
    this.budgetMin = [];
    this.budgetMin.push("2000");
    this.budgetMin.push("3000");
    this.budgetMin.push("5000");
    this.budgetMin.push("10000");
    this.budgetMin.push("15000");
    this.budgetMin.push("20000");
    this.budgetMin.push("25000");
    this.budgetMin.push("30000");
    this.budgetMin.push("35000");
    this.budgetMin.push("40000");
    this.budgetMin.push("45000");
    this.budgetMin.push("50000");
  }

  budgetMax: any = [];
  getBudgetMaxValue() {
    this.budgetMax = [];
    if (this.budgetMin.length > 0) {
      for (var i = 0; i < this.budgetMin.length; i++) {
        if (
          this.f.min_budget.value == "" ||
          parseInt(this.budgetMin[i]) >= parseInt(this.f.min_budget.value)
        )
          this.budgetMax.push(this.budgetMin[i]);
      }
    }

    return this.budgetMax;
  }

  listingLoader: boolean = false;
  getAllProperty() {
    if (this.searchForm.valid) {
      this.notscrolly = false;
      if (this.searchForm.value.property_type == "1" || this.searchForm.value.property_type == "2") {
        this.getRentSellProperty();
      } else if (this.searchForm.value.property_type == "3") {
        this.getPayingGuest();
      }

      if (isPlatformBrowser(this.platformId)) {
        window.scroll(0, 0);
      }
    }
  }

  getAllPropertyWithScroll() {
    if (this.searchForm.valid && this.notEmptyPost && this.notscrolly) {
      this.notscrolly = false;
      if (this.searchForm.value.property_type == "1" || this.searchForm.value.property_type == "2") {
        this.getRentSellProperty("yes");
      } else if (this.searchForm.value.property_type == "3") {
        this.getPayingGuest("yes");
      }
    }
  }

  getRentSellProperty(scroll = "no") {
    if (scroll == "no") {
      this.totalProperty = 0;
      this.listingLoader = true;
      this.service.loaderStatus = true;
    } else {
      this.spinner.show();
    }
        
    var data = this.searchForm.value;

    if (isPlatformBrowser(this.platformId) && scroll == "no") {
      window.scroll(0, 0);
    }

    data["property_type"] = this.searchForm.value.property_type;
    data["type"] = "Web";
    data["city_id"] = this.service.getSelectedCity.id;
    data["auth_token"] = this.service.getAuthorizationToken();
    data["offset"] = 0;
    data["limit"] = this.limit;
    this.properties = [];
    this.service.post("/propertyList", data).subscribe(
      (data) => {
        if (data[0].error == "0") {
          // Array.prototype.push.apply(this.properties, data[0].result); 
          this.properties = data[0].result;
           if (this.properties[0].property_type_name === "rent") {
          }
          this.offset += this.limit;
          if (this.service.isLoggedIn()) {
            var profileData = JSON.parse(localStorage.getItem("currentUser"));
            profileData.property_wishlistid = data[0].wishlist_id;
            localStorage.setItem("currentUser", JSON.stringify(profileData));
          }

          this.totalProperty = data[0].total_properties;
        } else {
          this.notEmptyPost = false;
        }
        this.notscrolly = true;
        this.service.loaderStatus = false;
        this.listingLoader = false;
        this.spinner.hide();
      },
      (error) => {
        this.properties = [];
        this.notscrolly = true;
        this.service.loaderStatus = false;
        this.listingLoader = false;
        this.spinner.hide();
      }
    );
  }

  getPayingGuest(scroll = "no") {
    if (scroll == "no") { 
      this.offset='0';
      this.totalProperty = 0;
      this.properties=[];
      this.notEmptyPost = true;
      this.notscrolly = true;
      this.listingLoader = true;
      this.service.loaderStatus = true;
    } else {
      this.spinner.show();
    }

    if (isPlatformBrowser(this.platformId) && scroll == "no") {
      window.scroll(0, 0);
    }
    
    var data = this.searchForm.value;
    data["type"] = "Web";
    data["auth_token"] = this.service.getAuthorizationToken();
    data["offset"] = this.offset;
    data["limit"] = this.limit;
    data["city_id"] = this.service.getSelectedCity.id;
    this.service.post("/getPayingGuestList", data).subscribe(
      (data) => {
        if (data[0].error == "0") {
          this.properties = [];
          Array.prototype.push.apply(this.properties, data[0].result); 
          this.offset += this.limit;
          if (this.service.isLoggedIn()) {
            var profileData = JSON.parse(localStorage.getItem("currentUser"));
            profileData.payingguest_wishlistid = data[0].wishlist_id;
            localStorage.setItem("currentUser", JSON.stringify(profileData));
          }
          this.totalProperty = data[0].total_properties;
        } else {
          this.notEmptyPost = false;
        }
        this.service.loaderStatus = false;
        this.listingLoader = false;
        this.notscrolly = true;
        this.spinner.hide();
      },
      (error) => {
        this.notscrolly = true;
        this.service.loaderStatus = false;
        this.listingLoader = false;
        this.spinner.hide();
      }
    );
  }

  get chkPropertyWishlist() {
    if (this.service.isLoggedIn()) {
      if (this.searchForm.value.property_type == "1" || this.searchForm.value.property_type == "2") {
        return this.service.getPropertyWishlistId.split(",");
      } else {
        return this.service.getPayingGuestWishlistId.split(",");
      }
    } else {
      return "";
    }
  }

  toggleProjectType1() {
    $("#flatoftype").toggleClass("type-class");
  }

  leadpropetyId: string = "";
  leadTableName: string = "";
  leadpropertyIdno:string = "";
  leadTablePropertyType:string ="";
  leadTableLookingType:string = "";
  leadPropertyPrice:string = "";
  leadPropertyTitle:string = "";

  openLeadForm(property_type: any, id: any,looking_type:any,propertyid_no, property:any) {
    this.leadpropetyId = id;
    var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));
    


    if (property_type == "1" || property_type == "2") {
      this.leadTableName = "tbl_property";
      this.leadpropertyIdno= propertyid_no; 
      this.leadTablePropertyType = property_type;
      this.leadTableLookingType = looking_type;
      this.leadPropertyPrice = property.priceinshort_words;
      this.leadPropertyTitle = property.property_title;
      // this. googleFacbookAnyalytics(property_type,looking_type,"AddToCart",[selectedCityData.name,propertyid_no])
    } else {
      this.leadTableName = "tbl_payingguest";
      this.leadpropertyIdno= propertyid_no;
      this.leadTablePropertyType = property_type;
      this.leadTableLookingType = looking_type;
      this.leadPropertyPrice = property.priceinshort_words;
      this.leadPropertyTitle = property.property_title;
      // if (environment.production) {
      //   this. googleFacbookAnyalytics(property_type,looking_type,"AddToCart",[selectedCityData.name,propertyid_no])
      // }
    }

    if(environment.production){
      this.service.sendEvents("contactNow", "contactNow", "contactNow");
      fbq('track', "contactNow" , {
        content_type: "contactNow",
        content_title: this.router.url,
      });

      this.service.sendEvents("AddToCart", "AddToCart", "AddToCart");
      fbq('track', "AddToCart" , {
        content_value: this.leadPropertyPrice,
        content_currency: "INR",
        content_name: this.leadPropertyTitle,
        content_ids: this.leadpropertyIdno,
        content_type: "AddToCart",
      });
    }

  }


  googleFacbookAnyalytics(property_type:any,looking_type:any,action,propertyID){

        var lookingType;
      if(looking_type == "1"){
        lookingType = "Residential"
      }else if(looking_type == "2"){
        lookingType = "Commercial"
      }else if(looking_type == "3"){
        lookingType = "Agriculture"
      }else if(looking_type == "4"){
        lookingType = "Industrial"
      }

      gtag('config', environment.gtagId, {
        'page_path': 'https://www.propira.com/search/leadForm'
      });
      if(property_type == "1"){
        this.service.sendEvents(
          "Rent",
          lookingType,
          action
        );
       this.triggerfacebookAnalytics("Rent",lookingType,propertyID,action)
      }else if(property_type == "2"){
        this.service.sendEvents(
          "Sell",
          lookingType,
          action
        );
        this.triggerfacebookAnalytics("Buy",lookingType,propertyID,action)
      }else if(property_type == "3"){
        this.service.sendEvents(
          "Pg",
          lookingType,
          action
        );
        this.triggerfacebookAnalytics("Pg",lookingType,propertyID,action)
      }
  }

  triggerfacebookAnalytics(eventCategory,lookingType,propertyID,events){

    fbq(
      'init', environment.fbId, {
      'track': 'https://www.propira.com/search/leadForm'
    }
    );
    fbq('track', events , {
      content_category:eventCategory,
      content_ids:propertyID,
      content_type: lookingType,
      content_price:this.leadPropertyPrice
    });
  
  }


  addToWishlist(property_id, event,looking_type,property_type,propertyid_no) {
    var selectedCityData = JSON.parse(localStorage.getItem('selSearchCity'));
   
    if (this.service.isLoggedIn()) {
      if (event.srcElement.classList.contains("shortlisted")) {
        event.srcElement.classList.remove("shortlisted");
        this.service.notificationPopup(
          "success",
          "Property successfully removed in the wishlist."
        );
      } else {
        event.srcElement.classList.add("shortlisted");
        if (environment.production) {
          this.googleFacbookAnyalytics(property_type,looking_type,'AddToWishlist',[selectedCityData.name,propertyid_no]);
        }

        this.service.notificationPopup(
          "success",
          "Property successfully added in the wishlist."
        );
      }

      this.service
        .post("/addPropertyWishlist", {
          type: "Web",
          auth_token: this.service.getAuthorizationToken(),
          property_type: this.searchForm.value.property_type,
          property_id: property_id,
        })
        .subscribe(
          (data) => {
            if (data[0].error == "1") {
              this.service.messageBox(
                "failed",
                "Something went wrong.please try again."
              );
            }
          },
          (error) => {
            this.service.messageBox(
              "failed",
              "Something went wrong.please try again."
            );
          }
        );
    } else {
      $("#loginModal").modal("toggle");
    }
  }

  mapData: any;
  setmap(event: any) { 
    this.mapData = event;
    console.warn('asa');  
    console.log(this.mapData);  
  }

  nearplaceList: any = [];
  findPlaces(types, radius, lat, long, map, className) {
    var cur_location = new google.maps.LatLng(lat, long);

    // prepare request to Places
    var request = {
      location: cur_location,
      radius: radius,
      types: [types],
    };

    this.nearplaceList = [];
    var service = new google.maps.places.PlacesService(map);
    service.nearbySearch(request, (results, status) => {
      $("." + className).css("display", "block");
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        this.nearplaceList = results;
        $("." + className).css("display", "none");
      } else if (
        status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS
      ) {
        $("." + className).css("display", "none");
      } else {
        $("." + className).css("display", "none");
      }
    });
  }

  nearByPlaceList(catType, className) {
    if (catType == "nearby") {
      var type =
        "bus_station,school,shopping_mall,hospital,atm,grocery_or_supermarket,pharmacy,restaurant,movie_theater,park,gym,petrol_station,bank";
      this.findPlaces(
        type,
        "200",
        this.location_lat,
        this.location_long,
        this.mapData,
        className
      );
    } else {
      this.findPlaces(
        catType,
        "1000",
        this.location_lat,
        this.location_long,
        this.mapData,
        className
      );
    }
  }

  resetFilters() {
    var homeSearchData = this.homesearch;
    homeSearchData.propertytype_subcat = "";
    homeSearchData.looking_type = "";
    localStorage.setItem("homesearch", JSON.stringify(homeSearchData));
    // this.searchForm.reset();
  }

  sharePost(type, url) {
    this.common.sharePost(type, url);
  }

}